<template>
	<div class="goods">
	 <van-nav-bar
   :title="title"
   left-arrow/>
<van-cell-group>
  <van-field
    v-model.trim="member.name"
    type="text"
    label="姓名"
    placeholder=""
  />
    <van-field
   :value="member.gender == 1?'男':'女'"
    type="text"
    label="性别"
    placeholder=""
  />
      <van-field
    :value="getName(member.memberType)"
    type="text"
    label="会员类型"
    placeholder=""
  />
     <van-field
    :value="member.expiryDate && member.expiryDate.substring(0,10)"
    type="text"
    label="有效期"
    placeholder=""

  />
    <van-field
    v-model.trim="member.memberNo"
    type="text"
    label="会员编号"
    placeholder=""

  />
    <van-field
    :value="getName('recommendUnitId')"
    type="text"
    label="所属机构"
    placeholder=""

  />
</van-cell-group>
      <!-- <p class="warm">
          <template v-if="warmTxt">
            {{warmTxt}}
          </template>
        </p> -->
<div class="nextBtn">
 <!-- <van-button  type="primary" @click="bind">绑 定</van-button> -->
</div>
	</div>
</template>
<script>
import {
  passwordSubmit,
  getMemberInfo,
  getCommonDictionary
} from "@/api/login";
import { Field, Button,Toast,CellGroup ,NavBar} from "vant";
import { getSessionStore } from "@/utils/sessionStorage";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
     title:"中国林学会会员信息",
      oldPassword: "",
      newPassword: "",
      newPasswordTwo: "",
       warmTxt: "",
       code:'',
      params:{
        code:'',
        mobile:''
      },
      member:{
          name:''
      },
      memberTypeList:[],

    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
  },
    computed: {
    ...mapState(["branchsList"]),

  },
  methods: {
          ...mapActions(["getBranchsList"]),
    getName(val){
        let obj = null;
        if('recommendUnitId' == val){
            obj = this.branchsList.find(item => item.code == this.member.recommendUnitId)
        }else{
            obj = this.memberTypeList.find(item => item.value == val)
        }
        if(obj){
            return obj.name;
        }
    }
  },
  mounted(){
 this.getBranchsList();
    getCommonDictionary('MEMBER_TYPE')
    .then(res =>{
        if(res.success){
            this.memberTypeList = res.result;
        }
    })

    var url = window.location.href; //获取url中"?"符后的字串 ('?modFlag=business&role=1')
    let begin = url.indexOf("?");
    let a  = url.substring(begin,url.length)

            var theRequest = new Object();

            if (a.indexOf("?") != -1) {
                var str = a.substr(1); //substr()方法返回从参数值开始到结束的字符串；
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
                }
               this.code = theRequest.code
               getMemberInfo({id:this.code})
               .then(res =>{
                   if(res.success){

                       this.member = res.result;
                   }
               })
            }


}
};
</script>

<style scoped>
body{ background:#fafafa; }
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.nextBtn{ padding: 0 20px; margin-top: 25px; text-align: center; }
/deep/.van-cell-group{ padding: 0 20px;border-top: #fff solid 15px; }
/deep/.van-button--normal{ width: 100%; }
/deep/.van-field__label{ width: 2.4rem;  color: #666; font-size:14px;}
/deep/.van-cell--required{padding-top:15px; padding-bottom: 15px;}
/deep/.van-cell{ border-bottom: #ededed solid 1px; }
</style>